module.exports = __webpack_public_path__ + "static/img/027政府诉求平台14.3232523.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/027政府诉求平台14.jpg
// module id = WATS
// module chunks = 0